import React from "react";
import Map from "../components/MapOpenlayers/Map";
import { Layers } from "../components/MapOpenlayers/Layers";
import LayerSwitcherControl from "../components/MapOpenlayers/Controls/LayerSwitcherControl";
import { fromLonLat } from "ol/proj";
import {
  Controls,
  FullScreenControl,
} from "../components/MapOpenlayers/Controls";
import ZoomControl from "../components/MapOpenlayers/Controls/ZoomControl";
import OLSidePanel from "../components/MapOpenlayers/SidePanel/SidePanelWebmap";
import Legend from "../components/MapOpenlayers/Legend/OutreachLegend";
import PrintMapControl from "../components/MapOpenlayers/PrintMap";
import BufferVectorTile from "../components/MapOpenlayers/Layers/BufferVT";
const mapCenter = fromLonLat([85, 28.5]);
const mapZoom = 7.2;
export default function OutreachMap() {
  return (
    <div className="row gx-0 gy-0">
      <div className="col-md-12 position-relative">
        <Map
          id="map"
          className="map"
          cssStyle={{ height: "100%", width: "100%" }}
          center={mapCenter}
          zoom={mapZoom}
        >
          <Legend />
          <Layers>
            <LayerSwitcherControl />
            <BufferVectorTile />
          </Layers>
          <Controls>
            <PrintMapControl title="Hard to reach Map" />
            <OLSidePanel />
            <FullScreenControl />
            <ZoomControl />
          </Controls>
        </Map>
      </div>
    </div>
  );
}
